let rippleEffect = (function () {
  function createRipple(event) {
    try {
      const button = event.currentTarget;
      const circle = document.createElement('span');
      const diameter = Math.max(button.clientWidth, button.clientHeight);
      const radius = diameter / 2;

      circle.style.width = circle.style.height = `${diameter}px`;

      let rect = button.getBoundingClientRect();

      const pageX = event.touches ? event.touches[0].clientX : event.clientX;
      const pageY = event.touches ? event.touches[0].clientY : event.clientY;

      circle.style.left = `${pageX - rect.left - radius}px`;
      circle.style.top = `${pageY - rect.top - radius}px`;
      circle.classList.add('ripple');

      const ripple = button.getElementsByClassName('ripple')[0];

      if (ripple) {
        ripple.remove();
      }

      button.appendChild(circle);
    } catch (error) {
      console.error('Ripple effect error:', error);
    }
    return true;
  }

  function init() {
    const buttons = document.querySelectorAll('[data-ripple-on-click]');
    const isTouchDevice = 'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;
    for (const button of buttons) {
      if (isTouchDevice) {
        button.addEventListener('touchstart', createRipple);
      } else {
        button.addEventListener('mousedown', createRipple);
      }
    }
  }

  return {
    init: init,
  };
})();
rippleEffect.init();
